import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import { IAddBlock, IBlockSearchList } from "Shared/Types/blockType";

const getBlockTypeList = createAsyncThunk(
  "blockType/getBlockTypeList",
  async (params: IBlockSearchList | null) => {
    try {
      const response = await api.blockType.getBlockTypeList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const addBlockType = createAsyncThunk(
  "blockType/addBlockType",
  async (data: IAddBlock, { dispatch }) => {
    try {
      const response = await api.blockType.addBlockType(data);
      dispatch(getBlockTypeList(null));
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export { addBlockType, getBlockTypeList };
